import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import BottomNavbar from './BottomNavbar';
import AIChatAssistant from '../common/AIChatAssistant';

const { Outlet } = ReactRouterDOM as any;

const PublicLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-surface text-foreground">
      <Navbar />
      <main className="flex-grow pb-16 md:pb-0">
        {children ?? <Outlet />}
      </main>
      <Footer />
      <BottomNavbar />
      <AIChatAssistant />
    </div>
  );
};

export default PublicLayout;
